// extracted by mini-css-extract-plugin
export default {"commentsContainer":"aDpx8W"};